<section class="storyblok-blok-container">
  <div class="seo-faq-content" [ngClass]="{ 'seo-faq-content__white-background': !isContentLandingPage }">
    <h2 class="seo-faq-content__title" test-target="seo-faq-content__title">
      {{ faqTitle }}
    </h2>

    <ng-container *ngFor="let faq of faqContent">
      <mm-expansion
        class="seo-faq-content__wrapper"
        [arrowToggler]="true"
        [expanded]="false"
        (toggled)="toggleOpen($event)"
      >
        <mm-expansion-title>
          <h2 class="seo-faq-content__question" test-target="seo-faq-content__question">{{ faq.question }}</h2>
        </mm-expansion-title>
        <p class="seo-faq-content__answer">
          {{ faq.answer }}
        </p>
      </mm-expansion>
    </ng-container>
  </div>
</section>
